import React,{useState,useEffect} from 'react'
import Header from './../components/Header.js';
import Footer from './../components/Footer.js';
import SearchMainComp from './../components/SearchMainComp';
import SearchCategoryComp from './../components/SearchCategoryComp';
import SearchFilters from './../components/SearchFilters';

const SearchPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
    },[])
    
  var [type,setType] = useState('')

  return (
    <>
      <Header setType={setType}/>
      <SearchCategoryComp  type={type} setType={setType} />
      <SearchFilters   type={type} setType={setType}/>
      <SearchMainComp  type={type} setType={setType} />
      <Footer/>

    </>
    )
}

export default SearchPage